import { parseLocalIsoDate } from "utils/date";

export const formatDate = (value?: string | null) => (
  value ? new Date(value).toLocaleString() : "-"
);

// Calendar dates must not go through `new Date(iso)` (UTC) or they render a day early in US zones.
export const formatDateOnly = (value?: string | null) => (
  parseLocalIsoDate(value)?.toLocaleDateString() ?? "-"
);

// Manual contracts record only the entered date (stored as UTC midnight), not a signing moment.
export const formatSignedAt = (
  { signedAt, manuallyEntered }: { signedAt?: string | null; manuallyEntered?: boolean | null },
) => (
  manuallyEntered ? formatDateOnly(signedAt) : formatDate(signedAt)
);
